import { getLeadOrdersDashboard } from '@/API/repositories/leadOrder';
import { useCommonDataContext } from '@/common/hooks/commonDataContext';
import { useRequestsContext } from '@/common/hooks/requestHook';
import { useEffect, useState } from 'react';

const useLeadOrders = () => {
	const { makeRequest, hasUnfilledRequest } = useRequestsContext();
	const {
		options: { queuesOptions },
	} = useCommonDataContext();
	const [data, setData] = useState();
	const [showAddPopup, setShowAddPopup] = useState();

	const openAddPopup = (queueId) => {
		const queue = queueId
			? queuesOptions.find((option) => option.value?._id === queueId)
			: null;
		setShowAddPopup({ queue: queue || '' });
	};

	const loadData = async () => {
		const response = await makeRequest(getLeadOrdersDashboard);

		if (response.data) {
			setData(response.data);
		}
	};

	useEffect(() => {
		loadData();
	}, []);

	const shouldShowLoading = hasUnfilledRequest(getLeadOrdersDashboard);

	return {
		data,
		showAddPopup,
		setShowAddPopup,
		openAddPopup,
		loadData,
		shouldShowLoading,
	};
};

export default useLeadOrders;
